<template>
  <div>
    <h2>Typische Klausuraufgaben</h2>
  </div>
  <div id="quizAKL2" align="left"></div>
  <button id="submitAKL2">Prüfen</button>
  <div id="resultsAKL2">
  </div>
</template>

<script>
function generateQuiz(
  questions,
  quizContainer,
  resultsContainer,
  submitButton,
  thisref
) {
  function showQuestions(questions, quizContainer) {
    // we'll need a place to store the output and the answer choices
    let output = [];
    let answers;
    let letter;

    // for each question...
    for (let i = 0; i < questions.length; i++) {
      // first reset the list of answers
      answers = [];

      // for each available answer to this question...
      for (letter in questions[i].answers) {
        // ...add an html radio button
        answers.push(
          "<label>" +
            '<input type="radio" name="question' +
            i +
            '" value="' +
            letter +
            '">' +
            // letter +
            // ": " +
            " " +
            questions[i].answers[letter] + 
            "</label>" 
        );
      }

      // add this question and its answers to the output
      output.push(
        "<br>" +
        '<h4 class="question">' +
          questions[i].question +
          "</h4>" +
          '<div class="answers">' +
          answers.join("<br>") +
          "</div>"
      );
    }

    // finally combine our output list into one string of html and put it on the page
    quizContainer.innerHTML = output.join("");
  }

  function showResults(questions, quizContainer, resultsContainer, thisref) {
    // gather answer containers from our quiz
    let answerContainers = quizContainer.querySelectorAll(".answers");

    // keep track of user's answers
    let userAnswer = "";
    let numCorrect = 0;

    // for each question...
    for (let i = 0; i < questions.length; i++) {
      // find selected answer
      userAnswer = (
        answerContainers[i].querySelector(
          "input[name=question" + i + "]:checked"
        ) || {}
      ).value;

      // if answer is correct
      if (userAnswer === questions[i].correctAnswer) {
        // add to the number of correct answers
        numCorrect++;

        // color the answers green
        answerContainers[i].style.color = "lightgreen";
      }
      // if answer is wrong or blank
      else {
        // color the answers red
        answerContainers[i].style.color = "red";
      }
    }

    if (numCorrect == 1){
      thisref.$store.commit('setTaskCompletionState', {varname: "audioKL2_done", state: true})
      localStorage.setItem("audioKL2_done", true);
    }

    // show number of correct answers out of total
    resultsContainer.innerHTML = numCorrect + " out of " + questions.length + "<br><br>" +
    "Formel: <font style='color: red'>Frequenz</font> = <font style='color: green'>Umdrehungen</font> / <font style='color: blue'>Zeit</font>(s)" + "<br><br>" +
    "Umdrehung = Frequenz * Zeit(s)" + "<br>" +
    "1h = 60min = 3600s" + "<br>" +
    "n = 163Hz * 3600 = 586800/s" + "<br>" +
    "n = 586800/s = 35208000/min = 2112480000/h";

  }

  // show the questions
  showQuestions(questions, quizContainer);

  // when user clicks submit, show results
  submitButton.onclick = function () {
    showResults(questions, quizContainer, resultsContainer, thisref);
  };
}
export default {
  name: "MultipleChoice",
  props: {
    msg: String,
  },
  data() {
    return {
      myQuestions: [
        {
          question: "Eine CD-Player spielt mit einer Frequenz von 163Hz. Unter der Vorraussetzung, dass der Motor konstant läuft: Wie wieviele Umdrehungen macht die CD in einer Stunde Spieldauer (vorausgesetzt ohne Unterbrechungen)?",
          answers: {
            a: "2112480000/h",
            b: "1011360000/h",
            c: "905860/h",
            d: "937090/h",
          },
          correctAnswer: "a",
        },
      ],
    };
  },
  mounted: function () {
    let quizContainer = document.getElementById("quizAKL2");
    let resultsContainer = document.getElementById("resultsAKL2");
    let submitButton = document.getElementById("submitAKL2");

    generateQuiz(
      this.myQuestions,
      quizContainer,
      resultsContainer,
      submitButton,
      this
    );
  },
};
</script>

<style scoped>
body {
  font-size: 20px;
  font-family: sans-serif;
  color: #333;
}
.question {
  font-weight: 600;
}
.answers {
  margin-bottom: 20px;
}
#submitAKL2 {
  font-family: sans-serif;
  font-size: 20px;
  background-color: #528382;
  color: #fff;
  border: 0px;
  border-radius: 3px;
  padding: 20px;
  cursor: pointer;
  margin-bottom: 20px;
}
#submit3:hover {
  background-color: #3a8;
}
</style>
